import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_PLATFORM_SETTING,
	FETCH_PLATFORM_SETTING_SUCCESS,
	FETCH_PLATFORM_SETTING_FAILED,

	UPDATE_PLATFORM_STATUS,
	UPDATE_PLATFORM_SETTING_MAINTENANCE,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: Map(),
	platformStatus: Map(),

	loadingStatus: NONE,
	loadingStatusMessage: '',
});

export default function platformSetting(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_PLATFORM_SETTING:
			return state
				.set('loadingStatus', LOADING)
				.set('loadingStatus', NONE);

		case FETCH_PLATFORM_SETTING_SUCCESS:
			return state
				.set('data', Map(action.setting))
				.set('loadingStatus', SUCCESS);

		case FETCH_PLATFORM_SETTING_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		case UPDATE_PLATFORM_STATUS:
			return state.set('platformStatus', Map(action.platform));

		case UPDATE_PLATFORM_SETTING_MAINTENANCE:
			return state.updateIn(['data', 'maintenance'], maintenance => ({ ...maintenance, ...action.maintenance }));

		default:
			return state;
	}
}
